import React from "react";
import ElectricityGenerationMixChart from "../ElectricityGenerationMixChart/ElectricityGenerationMixChart";

function PrintedtMix({ data, colors }) {
  return (
    <div>
      <div className="defaultMix">
        <ElectricityGenerationMixChart data={data} colors={colors} />
      </div>
      <div className="printedMix">
        <ElectricityGenerationMixChart
          width={731}
          data={data}
          colors={colors}
        />
      </div>
    </div>
  );
}

export default PrintedtMix;
